"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=message-metadata.js.map